import { render, staticRenderFns } from "./referrals.vue?vue&type=template&id=4ebd532e&scoped=true&"
import script from "./referrals.vue?vue&type=script&lang=js&"
export * from "./referrals.vue?vue&type=script&lang=js&"
import style0 from "./referrals.vue?vue&type=style&index=0&id=4ebd532e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ebd532e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ebd532e')) {
      api.createRecord('4ebd532e', component.options)
    } else {
      api.reload('4ebd532e', component.options)
    }
    module.hot.accept("./referrals.vue?vue&type=template&id=4ebd532e&scoped=true&", function () {
      api.rerender('4ebd532e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/personal-employee/referrals.vue"
export default component.exports